// =============================
// CoachPreviewDrawer Component
// =============================
import React, { useState } from "react";
import "./CoachPreviewDrawer.css"

function CoachPreviewDrawer(props) {
  var open = props.open;
  var payload = props.payload;
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;

  const [expanded, setExpanded] = useState(false);

  if (!open || !payload) return null;

  var detail = payload.CoachDetail || {};
  var fullName =
    (payload.Name || "") +
    (payload.Surname ? " " + payload.Surname : "");

  var titleLine = "";
  if (detail.UniversityName || detail.MajorName) {
    titleLine =
      (detail.UniversityName || "") +
      (detail.MajorName ? " | " + detail.MajorName : "");
  }

  var aboutText = detail.AboutMe || "";
  var maxChars = 220;
  var isLong = aboutText.length > maxChars;
  var shownText =
    expanded || !isLong
      ? aboutText
      : aboutText.substring(0, maxChars) + "...";

  var badges = detail.Badges || [];
  var ranks = payload.CoachRanks || [];
  var remainingSeats =
    typeof detail.RemainingSeats === "number"
      ? detail.RemainingSeats
      : null;

    function renderRankLabel(r) {
        if (!r || !r.Rank) return null;
      
        return r.ExamSubType + " • " + r.Rank;
      }
      
      function renderSeatText(remainingSeats) {
        if (remainingSeats === 0) {
          return "Takvimi Dolu";
        }
      
        if (remainingSeats > 0 && remainingSeats <= 3) {
          return (
            <>
              Son <strong>{remainingSeats}</strong> kişi
            </>
          );
        }
      
        if (remainingSeats > 3) {
          return (
            <>
              Kalan <strong>{remainingSeats}</strong> kişi
            </>
          );
        }
      
        return null;
      }
      

  return (
    <div className="coach-preview-overlay">
      <div className="coach-preview-drawer">
        {/* HEADER */}
        <div className="coach-preview-header">
          <div>
            <h2 className="coach-preview-title">Preview Coach Profile</h2>
            <p className="coach-preview-subtitle">
              Bu görünüm, uygulamada öğrencilerin göreceği karttır.
            </p>
          </div>
          <button
            type="button"
            className="coach-preview-close"
            onClick={onCancel}
          >
            ×
          </button>
        </div>

        {/* CONTENT */}
        <div className="coach-preview-body">
          <div className="coach-card">
            {/* Avatar */}
            <div className="coach-card-avatar-wrap">
              <div className="coach-card-avatar">
                {payload.ProfilePictureUrl ? (
                  <img
                    src={payload.ProfilePictureUrl}
                    alt={fullName}
                    className="coach-card-avatar-img"
                  />
                ) : (
                  <span className="coach-card-avatar-placeholder">
                    {payload.Name
                      ? payload.Name.charAt(0).toUpperCase()
                      : "?"}
                  </span>
                )}
              </div>
            </div>

            {/* Name + title */}
            <div className="coach-card-header-text">
              <div className="coach-card-name">{fullName || "İsim Yok"}</div>
              {titleLine && (
                <div className="coach-card-title">{titleLine}</div>
              )}
            </div>

            <div className="coach-card-divider" />

            {/* About */}
            {aboutText ? (
              <div className="coach-card-about">
                <p className="coach-card-about-text">{shownText}</p>
                {isLong && (
                  <button
                    type="button"
                    className="coach-card-expand-btn"
                    onClick={function () {
                      setExpanded(!expanded);
                    }}
                  >
                    {expanded ? "Daha Az Göster" : "Daha Fazla Göster"}
                  </button>
                )}
              </div>
            ) : (
              <div className="coach-card-about coach-card-about-empty">
                <p>Koç hakkında açıklama girilmemiş.</p>
              </div>
            )}

            <div className="coach-card-divider" />

            {/* Badges */}
            <div className="coach-card-section">
              <div className="coach-card-section-title">
                Koç sana hangi konularda yardımcı olabilir? 🤔
              </div>
              <div className="coach-card-badge-grid">
                {badges.length === 0 && (
                  <span className="coach-card-badge-empty">
                    Rozet seçilmemiş.
                  </span>
                )}
                {badges.map(function (b) {
                  return (
                    <div
                      key={b.Id || b.Name}
                      className="coach-card-badge-pill"
                    >
                      <span className="coach-card-badge-dot" />
                      <span>{b.Name}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Ranks */}
            {ranks && ranks.some(r => r.Rank) && (
  <div className="coach-card-section coach-card-ranks">
    <div className="coach-card-section-title">Dereceler</div>

    <div className="coach-card-rank-row">
      {ranks
        .filter(r => r.Rank) // ⬅️ only ranks with value
        .map(r => (
          <div
            key={r.ExamSubType || r.Id}
            className="coach-card-rank-pill"
          >
            {renderRankLabel(r)}
          </div>
        ))}
    </div>
  </div>
)}


            {/* Footer: remaining seats + CTA */}
            <div className="coach-card-footer">
            {remainingSeats !== null && (
  <div className="coach-card-seats">
    <span className="coach-card-seats-dot" />
    <span>{renderSeatText(remainingSeats)}</span>
  </div>
)}


              <button
                type="button"
                className="coach-card-cta"
                disabled={true}
              >
                Koçluk Al
              </button>
            </div>
          </div>
        </div>

        {/* DRAWER FOOTER BUTTONS */}
        <div className="coach-preview-footer">
          <button
            type="button"
            className="coach-preview-btn coach-preview-btn-secondary"
            onClick={onCancel}
          >
            Düzenlemeye Geri Dön
          </button>
          <button
            type="button"
            className="coach-preview-btn coach-preview-btn-primary"
            onClick={onConfirm}
          >
            Onayla ve Kaydet
          </button>
        </div>
      </div>
    </div>
  );
}

export { CoachPreviewDrawer };
